module.exports = __webpack_public_path__ + "img/SPCA.0f986e30.png";